import type { ApiError, NetworkError } from "@nexys/user-management-client";

/**
 * Discriminated unions from the client are { kind: "http" | "network" }.
 * This pulls a human string out of either without callers having to
 * pattern-match in every component.
 */
export const errorMessage = (
  error: ApiError | NetworkError | (ApiError | NetworkError),
  fallback = "Something went wrong."
): string => {
  if (error.kind === "network") {
    return "Network error — please check your connection and try again.";
  }
  return error.message || fallback;
};
